export const Namespace = "razume.si"
